export var ClickedModalValues;
(function (ClickedModalValues) {
    ClickedModalValues["Letsgo"] = "letsgo";
    ClickedModalValues["Dolater"] = "dolater";
    ClickedModalValues["Cross"] = "cross";
})(ClickedModalValues || (ClickedModalValues = {}));
export var ExitSetupButtonValues;
(function (ExitSetupButtonValues) {
    ExitSetupButtonValues["Top"] = "top";
    ExitSetupButtonValues["Bottom"] = "bottom";
})(ExitSetupButtonValues || (ExitSetupButtonValues = {}));
export var ResetModalClickedValues;
(function (ResetModalClickedValues) {
    ResetModalClickedValues["Ok"] = "ok";
    ResetModalClickedValues["Cancel"] = "cancel";
    ResetModalClickedValues["Cross"] = "cross";
    ResetModalClickedValues["Blur"] = "blur";
})(ResetModalClickedValues || (ResetModalClickedValues = {}));
export var ReminderPlatformValues;
(function (ReminderPlatformValues) {
    ReminderPlatformValues["Native"] = "native";
    ReminderPlatformValues["Mobile"] = "mobile";
})(ReminderPlatformValues || (ReminderPlatformValues = {}));
